const DateOnly = { weekday: "long", year: "numeric", month: "numeric", day: "numeric" };
const DateAndTime = { ...DateOnly, hour: "2-digit", minute: "2-digit", hour12: false };

export const isHannaGeorge = (doctorName) => {
  const name = (doctorName || "").toLowerCase().replace(/^dr\.?\s*/, "").trim().replace(/\s+/g, " ");
  return name === "hanna george" || name === "hanna";
};

export const hannaStepTranslationKey = (content) => {
  const stepType = /^Hanna(?:Golytely|Suflave|Suprep|Miralax)(Diet|Liquids|First|Second)$/.exec(content || "")?.[1];
  return {
    Diet: "Diet",
    Liquids: "SpecialLiquids",
    First: "FirstPortion",
    Second: "SecondPortion",
  }[stepType] || null;
};

const onDay = (procedureDate, daysBefore, hour, minute = 0) => {
  const date = new Date(procedureDate);
  date.setDate(date.getDate() - daysBefore);
  if (hour !== undefined) date.setHours(hour, minute, 0, 0);
  return date;
};

const step = (date, content, description, options = DateAndTime) =>
  ({ date, content, description, options, exactTime: options === DateAndTime });

const dietSteps = (procedureDate, prep) => [
  step(onDay(procedureDate, 2), `Hanna${prep}Diet`, "Switch to a low-fiber diet.", DateOnly),
  step(onDay(procedureDate, 1), `Hanna${prep}Liquids`,
    "24 hours before your procedure, start a clear liquid diet only.", DateOnly),
];

// Keep the supplied relative times tied to the case appointment time.
export function buildHannaGeorgeSchedule(procedureDate, procedureTime, concentrate) {
  const prep = (concentrate || "").split(",")[0].trim().toLowerCase();
  const time = /^(\d{1,2}):(\d{2})(?::\d{2})?$/.exec(procedureTime || "");
  if (!(procedureDate instanceof Date) || Number.isNaN(procedureDate.getTime()) ||
      !time || Number(time[1]) > 23 || Number(time[2]) > 59) return null;

  const procedure = onDay(procedureDate, 0, Number(time[1]), Number(time[2]));
  const hoursBefore = (hours) => new Date(procedure.getTime() - hours * 60 * 60 * 1000);

  if (/go.?lytely|golytley/.test(prep)) {
    return [
      ...dietSteps(procedureDate, "Golytely"),
      step(onDay(procedureDate, 1, 18), "HannaGolytelyFirst", "Take the first dose of the laxative solution."),
      { ...step(hoursBefore(6), "HannaGolytelySecond", "Take the second dose of the laxative solution."),
        exactTime: false, timeLabel: "6 hours prior to your procedure" },
    ];
  }
  if (prep.includes("suflave")) {
    return [
      ...dietSteps(procedureDate, "Suflave"),
      step(onDay(procedureDate, 1, 18), "HannaSuflaveFirst", "Take the first dose of the laxative solution."),
      { ...step(hoursBefore(6), "HannaSuflaveSecond", "Take the second dose of the laxative solution."),
        exactTime: false, timeLabel: "6 hours prior to your procedure" },
    ];
  }
  if (prep.includes("suprep")) {
    return [
      ...dietSteps(procedureDate, "Suprep"),
      step(onDay(procedureDate, 1, 18), "HannaSuprepFirst", "Take the first dose of the laxative solution."),
      { ...step(hoursBefore(6), "HannaSuprepSecond", "Take the second dose of the laxative solution."),
        exactTime: false, timeLabel: "6 hours prior to your procedure" },
    ];
  }
  if (prep.includes("miralax")) {
    return [
      ...dietSteps(procedureDate, "Miralax"),
      step(onDay(procedureDate, 1, 18), "HannaMiralaxFirst", "Take the first dose of the laxative solution."),
      step(onDay(procedureDate, 1, 21), "HannaMiralaxSecond", "Take the second dose of the laxative solution."),
    ];
  }
  return null;
}
